import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function CTA() {
  return <div className="w-full px-6 py-24" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="bg-slate-900 rounded-3xl p-12 md:p-16 text-center text-white relative overflow-hidden" data-id="element-17">
          {/* Subtle accent */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-blue-600/10 rounded-full blur-3xl" data-id="element-18"></div>
          <div className="relative z-10" data-id="element-19">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight" data-id="element-20">
              Ready to Transform Your Travel Payments?
            </h2>
            <p className="text-xl mb-10 text-slate-300 max-w-2xl mx-auto" data-id="element-21">
              Join thousands of travelers who trust Pomelo Services for secure,
              seamless international transactions
            </p>
            <div className="flex justify-center items-center mb-12" data-id="element-22">
              <a href="mailto:enquiries@pomeloservices.uk" className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-700 transition-all duration-200 shadow-lg shadow-blue-600/20" data-id="element-23">
                Contact Sales
              </a>
            </div>
            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center text-sm text-slate-300" data-id="element-24">
              <div className="flex items-center gap-2" data-id="element-25">
                <CheckCircleIcon className="w-5 h-5 text-blue-400" data-id="element-26" />
                <span data-id="element-27">Bank-Level Security</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-28">
                <CheckCircleIcon className="w-5 h-5 text-blue-400" data-id="element-29" />
                <span data-id="element-30">PCI DSS Certified</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-31">
                <CheckCircleIcon className="w-5 h-5 text-blue-400" data-id="element-32" />
                <span data-id="element-33">24/7 Support</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}